import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchLocationTypes: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'locationtype/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_LOCATIONTYPE_REQUEST,
                        types.SEARCH_LOCATIONTYPE_SUCCESS,
                        types.SEARCH_LOCATIONTYPE_FAILURE
                    ]
                }
            });
        },

    saveLocationType: (locationType) =>
        (dispatch) => {
            if (locationType.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'locationtype/create',
                        method: 'POST',
                        body: locationType,
                        types: [
                            types.CREATE_LOCATIONTYPE_REQUEST,
                            types.CREATE_LOCATIONTYPE_SUCCESS,
                            types.CREATE_LOCATIONTYPE_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'locationtype/update',
                        method: 'PUT',
                        body: locationType,
                        types: [
                            types.UPDATE_LOCATIONTYPE_REQUEST,
                            types.UPDATE_LOCATIONTYPE_SUCCESS,
                            types.UPDATE_LOCATIONTYPE_FAILURE
                        ]
                    }
                });
            }
        }
}
